import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import LanguageIcon from '@material-ui/icons/Language';

const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = lang => {
    if (lang) {
      localStorage.setItem('language', lang);
      i18n.changeLanguage(lang);
    }
    setAnchorEl(null);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '4px',
        right: '4px',
        width: 'auto',
        zIndex: 2000,
      }}
    >
      <IconButton color="inherit" onClick={handleClick}>
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => handleClose(null)}
      >
        <MenuItem onClick={() => handleClose('en')}>
          <span role="img" aria-label="English" style={{ marginRight: 8, fontSize: '1.2rem' }}>
            🇬🇧
          </span>
          English
        </MenuItem>
        <MenuItem onClick={() => handleClose('it')}>
          <span role="img" aria-label="Italian" style={{ marginRight: 8, fontSize: '1.2rem' }}>
            🇮🇹
          </span>
          Italiano
        </MenuItem>
        <MenuItem onClick={() => handleClose('de')}>
          <span role="img" aria-label="German" style={{ marginRight: 8, fontSize: '1.2rem' }}>
            🇩🇪
          </span>
          Deutsch
        </MenuItem>
      </Menu>
    </div>
  );
};

export default LanguagePicker;
